import type { FC, ReactNode } from 'react'

import { Star } from 'lucide-react'
import { cn } from '@/lib/utils'

interface StarRatingProps {
    value: number
    className?: string
    starClassName?: string
    trackClassName?: string
}

const STARS = [0, 1, 2, 3, 4]

const StarRating: FC<StarRatingProps> = ({
    value,
    className,
    starClassName = 'size-4',
    trackClassName = 'text-border'
}): ReactNode => {
    const percent = Math.max(0, Math.min(100, (value / 5) * 100))

    return (
        <span role='img' aria-label={`Rated ${value.toFixed(1)} out of 5`} className={cn('relative inline-flex', className)}>
            <span className={cn('flex gap-0.5', trackClassName)}>
                {STARS.map(star => (
                    <Star key={star} className={cn('shrink-0', starClassName)} fill='currentColor' strokeWidth={0} aria-hidden='true' />
                ))}
            </span>

            <span className='absolute inset-y-0 left-0 overflow-hidden text-brand-orange' style={{ width: `${percent}%` }}>
                <span className='flex w-max gap-0.5'>
                    {STARS.map(star => (
                        <Star key={star} className={cn('shrink-0', starClassName)} fill='currentColor' strokeWidth={0} aria-hidden='true' />
                    ))}
                </span>
            </span>
        </span>
    )
}

export default StarRating
